import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  justify-content: space-between;
  width: 100%;
  .ant-divider-horizontal {
    margin: 0;
  }
`;

export const EmptyWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 16px;
  color: ${({ theme }) => theme.colors.black5};
`;

export const ViewMoreWrapper = styled.div`
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
  cursor: pointer;
`;

export const EmojiWrapper = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  font-size: 30px;
  font-weight: 600;
  line-height: 40px;
  letter-spacing: -0.5px;
`;
